import React from 'react';
import { Row, Col, Card, Typography } from 'antd';
//import '../../assets/styles/FeaturedSubjects.css';

const { Meta } = Card;
const { Paragraph } = Typography;

const categoryStats = {
  "AI & Machine Learning": { courses: 23, learners: "200+" },
  "Cybersecurity": { courses: 20, learners: "100+" },
  "Data Science": { courses: 26, learners: "250+" },
};

const FeaturedSubjects = () => {
  const handleImageError = (e) => {
    e.target.src = '/images/placeholder.jpg';
  };

  return (
    <Row gutter={16} className="featured-subjects-wrapper">
      <Col span={24}>
        <div className="featured-subjects">
          <h2>JectHub Features</h2>
          <p>
            At JectHub, our mission is to be Africa's leading platform for advancing knowledge in Artificial Intelligence (AI) & Machine Learning, Cybersecurity, and Data Science through free online tuition. Explore our featured subjects, expertly crafted to empower you with cutting-edge skills, helping you master these transformative technologies and stay ahead in the tech industry.
          </p>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8}>
              <Card
                hoverable
                className="animated-card ai-card"
                cover={<img alt="AI & Machine Learning fundamentals" src="/images/ai-ml.jpeg" onError={handleImageError} />}
              >
                <Meta
                  title="AI & Machine Learning"
                  description={
                    <>
                      <Paragraph>Discover the fundamentals of AI and Machine Learning, from algorithms and data processing to practical applications. Enhance your skills to excel in the field of AI.</Paragraph>
                      <Paragraph>
                        <strong>Courses:</strong> {categoryStats["AI & Machine Learning"].courses} · <strong>Learners:</strong> {categoryStats["AI & Machine Learning"].learners}
                      </Paragraph>
                    </>
                  }
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Card
                hoverable
                className="animated-card cyber-card"
                cover={<img alt="Cybersecurity principles" src="/images/cybersecurity.jpeg" onError={handleImageError} />}
              >
                <Meta
                  title="Cybersecurity"
                  description={
                    <>
                      <Paragraph>Master the principles of cybersecurity, including protecting systems and networks from cyber threats. Gain expertise in securing digital assets and combating cyber attacks.</Paragraph>
                      <Paragraph>
                        <strong>Courses:</strong> {categoryStats["Cybersecurity"].courses} · <strong>Learners:</strong> {categoryStats["Cybersecurity"].learners}
                      </Paragraph>
                    </>
                  }
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Card
                hoverable
                className="animated-card data-card"
                cover={<img alt="Data Science techniques" src="/images/data-science.jpeg" onError={handleImageError} />}
              >
                <Meta
                  title="Data Science"
                  description={
                    <>
                      <Paragraph>Explore data science techniques, from data analysis and statistics to extracting actionable insights from large data sets. Learn how to leverage data for informed decision-making.</Paragraph>
                      <Paragraph>
                        <strong>Courses:</strong> {categoryStats["Data Science"].courses} · <strong>Learners:</strong> {categoryStats["Data Science"].learners}
                      </Paragraph>
                    </>
                  }
                />
              </Card>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default FeaturedSubjects;